import { useLanguage } from '@/i18n';
import { Fragment, useRef, useState } from 'react';
import {
  Menu,
  MenuIcon,
  MenuItem,
  MenuLabel,
  MenuSub,
  MenuTitle,
  MenuToggle
} from '../menu';
import { KeenIcon } from '../keenicons';

const NavbarDropdown = () => {
  const itemRef = useRef<any>(null);
  const { isRTL } = useLanguage();

  return (
    <Fragment>
      <Menu className="items-stretch">
        <MenuItem
          ref={itemRef}
          toggle="dropdown"
          trigger="click"
          dropdownProps={{
            placement: isRTL() ? 'bottom-start' : 'bottom-end',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: isRTL() ? [0, -10] : [0, 10] // [skid, distance]
                }
              }
            ]
          }}
        >
          <MenuToggle className="btn btn-sm btn-icon btn-light">
            <KeenIcon icon="dots-vertical" />
          </MenuToggle>

        </MenuItem>
      </Menu>
    </Fragment>
  );
};

export { NavbarDropdown };
